<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('summaryInventoryList.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('summaryInventoryList.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div class="ts-flex ts-items-center ts-space-x-3">
            <a-date-picker
              v-model="asOfDate"
              :allowClear="false"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              style="width: 200px"
              @change="fetchData()"
            />
          </div>
          <div class="d-flex ts-space-x-3 ts-items-center">
            <a-select
              v-model="categoryId"
              mode="multiple"
              :placeholder="$t('inventoryList.category')"
              :options="product_categories"
              :maxTagTextLength="17"
              :maxTagCount="1"
              style="width:250px"
            ></a-select>
            <ts-branch-filter
              :isPlaceholder="true"
              @filter="filterBranch"
            ></ts-branch-filter>
            <!-- <ts-location-filter
              :isDefaultSelect="false"
              @filter="filterLocaton"
            ></ts-location-filter> -->
            <a-select
              style="width:257px"
              v-model="location_id"
              :options="locations"
              showSearch
              mode="multiple"
              :filterOption="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
              :maxTagCount="1"
              :maxTagTextLength="17"
              :placeholder="$t('all')"
              @change="filterLocaton"
            ></a-select>
            <ts-input
              v-model="search"
              v-tooltip="$t('inventoryList.search')"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-loading-banner :loading="loading">
        <div class="overflow-auto">
          <ts-table :records="summaryResources">
            <template v-slot:thead>
              <tr>
                <th
                  rowspan="2"
                  class="ts-uppercase ts-bg-gray-200 ts-align-middle ts-border-r ts-border-gray-500"
                >
                  {{ $t('inventoryList.barcode') }}
                </th>
                <th
                  rowspan="2"
                  class="ts-uppercase ts-bg-gray-200 ts-border-r ts-border-gray-500"
                >
                  {{ $t('inventoryList.category') }}
                </th>
                <th
                  rowspan="2"
                  class="ts-uppercase ts-bg-gray-200 ts-border-r ts-border-gray-500 ts-whitespace-no-wrap "
                >
                  {{ $t('inventoryList.productGroup') }}
                </th>
                <th
                  rowspan="2"
                  class="ts-uppercase ts-bg-gray-200 ts-border-r ts-border-gray-500"
                >
                  {{ $t('inventoryList.description') }}
                </th>
                <th
                  rowspan="2"
                  class="ts-uppercase ts-bg-gray-200 ts-border-r ts-border-gray-500"
                >
                  {{ $t('inventoryList.storage') }}
                </th>
                <th
                  rowspan="2"
                  class="ts-uppercase ts-bg-gray-200 ts-border-r ts-border-gray-500"
                >
                  {{ $t('inventoryList.begin') }}
                </th>
                <th rowspan="2" class="ts-uppercase ts-bg-gray-200 ts-border-r ts-border-gray-500">{{ $t('inventoryList.cost') }}</th>
                <th rowspan="2" class="ts-uppercase ts-bg-gray-200 ts-border-r ts-border-gray-500 ts-whitespace-no-wrap">{{ $t('inventoryList.retailPrice') }}</th>
                <th rowspan="2" class="ts-uppercase ts-bg-gray-200 ts-border-r ts-border-gray-500 ts-whitespace-no-wrap">{{ $t('inventoryList.dealerPrice') }}</th>
                <th
                  colspan="5"
                  class="ts-uppercase ts-bg-gray-200 ts-text-center ts-border ts-border-gray-500"
                >
                  {{ $t('inventoryList.in') }}
                </th>
                <th
                  colspan="7"
                  class="ts-uppercase ts-bg-gray-200 ts-text-center ts-border ts-border-gray-500"
                >
                  {{ $t('inventoryList.out') }}
                </th>
                <th
                  rowspan="2"
                  class="ts-uppercase ts-bg-gray-200 ts-border-r ts-border-gray-500"
                >
                  {{ $t('inventoryList.ending') }}
                </th>
                <th class="ts-bg-gray-200 ts-text-center ts-uppercase ts-border-r ts-border-gray-500 ts-whitespace-no-wrap" rowspan="2">{{ $t('inventoryList.totalCost') }}</th>
                <th class="ts-bg-gray-200 ts-text-center ts-uppercase ts-border-r ts-border-gray-500 ts-whitespace-no-wrap" rowspan="2">{{ $t('inventoryList.totalRetailPrice') }}</th>
                <th class="ts-bg-gray-200 ts-text-center ts-uppercase ts-border-r ts-border-gray-500 ts-whitespace-no-wrap" rowspan="2">{{ $t('inventoryList.totalDealerPrice') }}</th>
              </tr>
              <tr>
                <!-- column merge in -->
                <th
                  class="ts-bg-gray-200 ts-text-center ts-uppercase ts-border-r ts-border-l ts-border-gray-500"
                >
                  {{ $t('inventoryList.stock') }}
                </th>
                <th
                  class="ts-bg-gray-200 ts-text-center ts-uppercase ts-border-r ts-border-gray-500"
                >
                  {{ $t('inventoryList.transfer') }}
                </th>
                <th
                  class="ts-bg-gray-200 ts-text-center ts-uppercase ts-border-r ts-border-gray-500"
                >
                  {{ $t('inventoryList.adjustment') }}
                </th>
                <th
                  class="ts-bg-gray-200 ts-text-center ts-uppercase ts-border-r ts-border-gray-500 ts-whitespace-no-wrap"
                >
                  {{ $t('inventoryList.fromVendor') }}
                </th>
                <th
                  class="ts-bg-gray-200 ts-text-center ts-uppercase ts-border-r ts-border-gray-500"
                >
                  {{ $t('inventoryList.total') }}
                </th>

                <!-- column merge out -->
                <th
                  class="ts-bg-gray-200 ts-text-center ts-uppercase ts-border-r ts-border-gray-500"
                >
                  {{ $t('inventoryList.sale') }}
                </th>
                <th
                  class="ts-bg-gray-200 ts-text-center ts-uppercase ts-border-r ts-border-gray-500"
                >
                  {{ $t('inventoryList.transfer') }}
                </th>
                <th
                  class="ts-bg-gray-200 ts-text-center ts-uppercase ts-border-r ts-border-gray-500"
                >
                  {{ $t('inventoryList.adjustment') }}
                </th>
                <th
                  class="ts-bg-gray-200 ts-text-center ts-uppercase ts-border-r ts-border-gray-500 ts-whitespace-no-wrap"
                >
                  {{ $t('inventoryList.toVendor') }}
                </th>
                <th
                  class="ts-bg-gray-200 ts-text-center ts-uppercase ts-border-r ts-border-gray-500 ts-whitespace-no-wrap"
                >
                  {{ $t('inventoryList.writeOff') }}
                </th>
                <th
                  class="ts-bg-gray-200 ts-text-center ts-uppercase ts-border-r ts-border-gray-500 ts-whitespace-no-wrap"
                >
                  {{ $t('inventoryList.spReplacement') }}
                </th>
                <th
                  class="ts-bg-gray-200 ts-text-center ts-uppercase ts-border-r ts-border-gray-500"
                >
                  {{ $t('inventoryList.total') }}
                </th>
              </tr>
            </template>

            <template v-slot="{ record }">
              <td>{{ record.barcode }}</td>
              <td>{{ record.category }}</td>
              <td>{{ record.product_group }}</td>
              <td class="ts-whitespace-no-wrap">{{ record.product_name }}</td>
              <td class="ts-whitespace-no-wrap">{{ record.storage_location }}</td>
              <td>{{ record.begining_balance }}</td>
              <td class="ts-whitespace-no-wrap ts-text-right">{{ $currencyFormat(record.cost) }}</td>
              <td class="ts-whitespace-no-wrap ts-text-right">{{ $currencyFormat(record.retail_price) }}</td>
              <td class="ts-whitespace-no-wrap ts-text-right">{{ $currencyFormat(record.dealer_price) }}</td>
              <td class="ts-text-center">
                {{ record.quantity_in ? record.quantity_in : '-' }}
              </td>
              <td class="ts-text-center">
                {{ record.trasnfer_in ? record.trasnfer_in : '-' }}
              </td>
              <td class="ts-text-center">
                {{ record.adjustment_in ? record.adjustment_in : '-' }}
              </td>
              <td class="ts-text-center">
                {{
                  record.return_from_vendor_in
                    ? record.return_from_vendor_in
                    : '-'
                }}
              </td>
              <td class="ts-text-center">
                {{ record.total_in ? record.total_in : '-' }}
              </td>

              <td class="ts-text-center">
                {{ record.qauntity_out ? record.qauntity_out : '-' }}
              </td>
              <td class="ts-text-center">
                {{ record.transfer_out ? record.transfer_out : '-' }}
              </td>
              <td class="ts-text-center">
                {{ record.adjustment_out ? record.adjustment_out : '-' }}
              </td>
              <td class="ts-text-center">
                {{
                  record.return_to_vendor_out
                    ? record.return_to_vendor_out
                    : '-'
                }}
              </td>
              <td class="ts-text-center">
                {{ record.write_off_out ? record.write_off_out : '-' }}
              </td>
              <td class="ts-text-center">
                {{
                  record.sp_replacement_out ? record.sp_replacement_out : '-'
                }}
              </td>
              <td class="ts-text-center">
                {{ record.total_out ? record.total_out : '-' }}
              </td>

              <td>{{ record.ending_balance }}</td>
              <td class="ts-text-right">{{ record.ending_balance ? multiplier(record.ending_balance, record.cost) : '-' }}</td>
              <td class="ts-text-right">{{ record.ending_balance ? multiplier(record.ending_balance, record.retail_price) : '-' }}</td>
              <td class="ts-text-right">{{ record.ending_balance ? multiplier(record.ending_balance, record.dealer_price) : '-' }}</td>
            </template>
          </ts-table>
        </div>
      </ts-loading-banner>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="summaryPagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'summaryInventoryList',
  data () {
    return {
      loading: false,
      location_id: [],
      locations: []
    }
  },
  computed: {
    ...mapState('stock/inventoryList', [
      'summaryResources',
      'summaryPagination',
      'product_categories'
    ]),
    search: {
      get () {
        return this.$store.state.stock.inventoryList.summary_search
      },
      set (newValue) {
        this.$store.commit('stock/inventoryList/SET_SUMMARY_SEARCH', newValue)
        this.$store.commit('stock/inventoryList/RESET_CURRENT_PAGE')
      }
    },
    asOfDate: {
      get () {
        return this.$store.state.stock.inventoryList.asOfDate
      },
      set (newValue) {
        this.$store.commit('stock/inventoryList/SET_AS_OF_DATE', newValue)
      }
    },
    categoryId: {
      get () {
        return this.$store.state.stock.inventoryList.category_id_summary
      },
      set (newValue) {
        this.$store.commit(
          'stock/inventoryList/SET_CATEGORY_ID_SUMMARY',
          newValue
        )
      }
    }
  },
  methods: {
    ...mapActions('report/resource', ['getLocation']),
    async fetchCategory (attributes) {
      this.loading = true
      await this.getLocation().then(response => {
        this.locations = response.data.map(el => ({
          value: el.location_id,
          label: el.location_name_en + ' | ' + el.branch.branch_name_en
        }))
      })
      this.$store
        .dispatch('stock/inventoryList/getProductCategory', { ...attributes })
        .then(() => {})
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('stock/inventoryList/fetchSummary', { ...attributes })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    filterLocaton (value) {
      this.$store.commit('stock/inventoryList/SET_LOCATION_ID_SUMMARY', value)
      this.fetchData({
        search: this.search
      })
    },
    filterBranch (value) {
      this.changeBranch(value)
      this.$store.commit('stock/inventoryList/SET_BRANCH_ID_SUMMARY', value)
      this.fetchData({
        search: this.search
      })
    },
    changeBranch (value) {
      this.loading = true
      this.getLocation({
        branch_id: JSON.parse('[' + value + ']')
      })
        .then(response => {
          this.locations = response.data.map(el => ({
            value: el.location_id,
            label: el.location_name_en + ' | ' + el.branch.branch_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    multiplier(num1, num2) {
      return this.$currencyFormat( parseFloat(num1) * parseFloat(num2))
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({
        search: search
      })
    }, 500),
    categoryId: debounce(function (search) {
      this.fetchData({
        search: this.search
      })
    }, 500)
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fetchData()
      vm.fetchCategory()
    })
  }
}
</script>

<style scoped>
.table th {
  padding: 0.75rem;
  vertical-align: middle !important;
  border-top: 1px solid #d3d3d3;
}
</style>
